export default "__VITE_ASSET__DaymPcy5__"